import React from 'react';

function ModuleCardWrapper({ icon, title, description, children }) {
  return (
    <div className="module-card h-full flex flex-col">
      {/* 标题栏 */}
      <div className="flex items-center mb-2 space-x-2">
        <span className="text-xl">{icon}</span>
        <h2 className="module-title">{title}</h2>
      </div>

      {/* 描述 */}
      <p className="module-desc">{description}</p>

      {/* 内容区 */}
      <div className="flex-grow flex flex-col justify-start">
        {children}
      </div>
    </div>
  );
}

export default ModuleCardWrapper;

